<template>
  <div class="page-main">
    <div class="flex flex-y-center flex-wrap m-b-10">
      <el-form class="flex flex-y-center" @submit.native.prevent="searchListData">
        <span>统计日期:</span>
        <e-date-picker
          type="daterange"
          :value.sync="dateRange"
          isShowFast
          @change="searchListData"
        />
        <span class="m-l-10">仓库:</span>
        <el-select v-model="formFilter.warehouse_id" size="mini" clearable class="m-l-5 w-140" @change="searchListData">
          <el-option v-for="opt in warehouseOptions" :key="opt.val" :label="opt.key" :value="opt.val" />
        </el-select>
        <el-input v-model="formFilter.material_name" size="mini" clearable placeholder="物料名称" class="m-l-10 w-140" @change="searchListData" />
        <el-input v-model="formFilter.category" size="mini" clearable placeholder="材质" class="m-l-10 w-100" @change="searchListData" />
        <el-input v-model="formFilter.spec" size="mini" clearable placeholder="规格" class="m-l-10 w-120" @change="searchListData" />
        <el-input v-model="formFilter.batch_no" size="mini" clearable placeholder="批号" class="m-l-10 w-120" @change="searchListData" />
        <el-button type="primary" size="mini" icon="el-icon-search" class="m-l-10" @click="searchListData">查询</el-button>
        <el-button size="mini" icon="el-icon-refresh" :disabled="!hasFilter" @click="resetFilter">重置</el-button>
      </el-form>
      <span class="m-l-10 c-gray">期初=区间前累计结存，本期收入/发出=区间内出入库流水，期末=期初+收入-发出</span>
    </div>
    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :show-footer="!!tableData.length"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 148"
      :footer-method="footerMethod"
      @resizable-change="handleColumnResize"
    >
      <template #default_in_qty="{ row }">
        <span class="c-green">{{ row.in_qty }}</span>
      </template>
      <template #default_out_qty="{ row }">
        <span class="c-red">{{ row.out_qty }}</span>
      </template>
      <template #default_end_qty="{ row }">
        <span class="c-orange">{{ row.end_qty }}</span>
      </template>

      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  tableName: 'new_stock_inventory_sfc',
  data() {
    return {
      loading: true,
      dateRange: [
        this.$XEUtils.toDateString(this.$XEUtils.beginOfMonth(new Date()), 'yyyy-MM-dd'),
        this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd')
      ],
      formFilter: {
        warehouse_id: '',
        material_name: '',
        category: '',
        spec: '',
        batch_no: ''
      },
      warehouseList: [],
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        begin_qty_all: '',
        in_qty_all: '',
        out_qty_all: '',
        end_qty_all: ''
      }
    }
  },
  computed: {
    hasFilter() {
      return Object.values(this.formFilter).some((val) => val !== '' && val !== null && val !== undefined)
    },
    warehouseOptions() {
      return this.warehouseList.map((item) => ({ key: item.warehouse_name, val: item.id }))
    },
    tableColumn() {
      let result = [
        { fixed: 'left', title: '序号', type: 'seq', width: 40 },
        { title: '仓库', field: 'warehouse_name', width: 120 },
        { title: '物料名称', field: 'material_name', width: 150 },
        { title: '材质', field: 'category', width: 90 },
        { title: '规格(mm)', field: 'spec', width: 130 },
        { title: '批号', field: 'batch_no', width: 120 },
        { title: '单位', field: 'unit', width: 60 },
        { title: '期初数量', field: 'begin_qty', width: 100 },
        { title: '本期收入', field: 'in_qty', slots: { default: 'default_in_qty' }, width: 100 },
        { title: '本期发出', field: 'out_qty', slots: { default: 'default_out_qty' }, width: 100 },
        { title: '期末数量', field: 'end_qty', slots: { default: 'default_end_qty' }, width: 100 }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getWarehouseList()
    this.getListData()
  },
  methods: {
    getWarehouseList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/newWarehouse/list',
        data: { currentPage: 1, pageSize: this.$constant.pageMax, sortData: 'id desc' }
      })
        .then((res) => {
          if (res.status === 200) {
            this.warehouseList = (res.data.page && res.data.page.list) || []
          }
        })
        .catch(() => {})
    },
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    resetFilter() {
      Object.keys(this.formFilter).forEach((key) => {
        this.formFilter[key] = ''
      })
      this.searchListData()
    },
    getListData() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning('请选择统计日期区间')
        return
      }
      this.loading = true
      let filterData = {}
      Object.keys(this.formFilter).forEach((key) => {
        let val = this.formFilter[key]
        if (val !== '' && val !== null && val !== undefined) {
          filterData[key] = val
        }
      })
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        filterData
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/inventory/sfcList',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = this.$util.deepCopy(data.list) || []
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.begin_qty_all = res.data.begin_qty_all
            this.totalObj.in_qty_all = res.data.in_qty_all
            this.totalObj.out_qty_all = res.data.out_qty_all
            this.totalObj.end_qty_all = res.data.end_qty_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'begin_qty') return this.totalObj.begin_qty_all
          if (column.field === 'in_qty') return this.totalObj.in_qty_all
          if (column.field === 'out_qty') return this.totalObj.out_qty_all
          if (column.field === 'end_qty') return this.totalObj.end_qty_all
        })
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  .w-140 {
    width: 140px;
  }
  .w-120 {
    width: 120px;
  }
  .w-100 {
    width: 100px;
  }
}
</style>
